
import Component, { mixins } from "vue-class-component"
import Calculator from "../mixins/Calculator.vue"
import { Prop } from "vue-property-decorator"
import { Bestellung, AbholungStatus } from "mangdto"
import { EnumFormatter } from "mangutil"

@Component
export default class BestellungRowAbholung extends mixins(Calculator) {
  @Prop() bestellung: Bestellung

  AbholungStatus = AbholungStatus

  formatiereAbholungStatus(bestellung: Bestellung): string {
    return EnumFormatter.formatAbholungStatus(bestellung.abholung.status)
  }
}
